import styled, { css } from 'styled-components';

export const Container = styled.main`
  ${({ theme }) => css`
    flex: 1;
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    row-gap: ${theme.layout.spacing(4)};

    .informations {
      text-align: center;
      width: 70%;
    }

    .title {
      color: ${theme.palette.text.main};
      font-size: ${theme.typography.sizes.title1};
      margin-bottom: 0.75rem;
    }

    .message {
      color: ${theme.palette.text.light};
      font-size: ${theme.typography.sizes.body1};
    }

    @media screen and (max-width: ${theme.layout.breakpoints.md}) {
      padding: ${theme.layout.spacing(3)};
      row-gap: ${theme.layout.spacing(3)};

      .title {
        font-size: ${theme.typography.sizes.title2};
      }

      .informations {
        width: 100%;
      }
    }
  `}
`;
